import * as React from 'react';

import type { IIntersection } from './intersection.context.types';

const IntersectionContext = React.createContext<IIntersection | undefined>(void 0);

export default IntersectionContext;